import { MobileRouterPaths } from "../../mobileAppCore/mobileAppConstants";

export const PAGES_ZENDESK_FIXED_BUTTON_IS_VISIBLE = [
    MobileRouterPaths.confirm,
    MobileRouterPaths.forgot,
    MobileRouterPaths.login,
    MobileRouterPaths.registration,
    MobileRouterPaths.reset,
];

export const ZENDESK_WEB_WIDGET_TYPES = {
    CLASSIC: 'classic',
    STANDARD: 'standard',
} as const;
